"use strict";

exports.__esModule = true;
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SpinnerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Spinner__SpinnerWrapper",
  componentId: "sc-1uc8g6p-0"
})(["margin:auto;display:flex;height:-webkit-fill-available;width:-webkit-fill-available;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;"]);
var Spinner = exports.Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? _core.Spinner.SIZE_STANDARD : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(SpinnerWrapper, {
    "data-testid": "Spinner"
  }, /*#__PURE__*/_react["default"].createElement(_core.Spinner, {
    size: size
  }));
};